import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import ApiEndpoint from '../../services/ApiEndpoint';
import {take} from 'rxjs/operators';
import {ErrorReportComponent} from '../control-report/cr-issue/error-report/error-report.component';
import {AlertService} from '../../services/alert/alert.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {SseService} from '../../services/sse/sse.service';
import {EntityErrorReportComponent} from "./entity-error-report/entity-error-report.component";
import {
  ConfirmationModalFcaComponentComponent
} from "../query-management/modals/confirmation-modal-fca-component/confirmation-modal-fca-component.component";

@Injectable({
  providedIn: 'root'
})
export class FcaService {

  constructor(private http: HttpClient, private alerts: AlertService,
              private modalService: BsModalService,
              private sse: SseService,
              public bsModalRef: BsModalRef) {
  }

  getActiveTeams(): Observable<any> {
    return this.http.get<any[]>(`${ApiEndpoint.fcaURL}/fca-request/active-teams`);
  }

  fcaConfigData(segment: string, parameter: string, startDate = null, compType = null, region = ''): Observable<any> {
    const params = new HttpParams()
      .set('segment', segment)
      .set('parameter', parameter)
      .set('startDate', startDate)
      .set('compType', compType)
      .set('region', region);
    return this.http.get(`${ApiEndpoint.fcaURL}/fca-request/config/data`, {params: params});
  }

  fetchGeoArea(segment: string, parameter: string, region: string, district: string, thana: string, area: string): Observable<any> {
    const params = new HttpParams()
      .set('segment', segment)
      .set('parameter', parameter)
      .set('district', district)
      .set('thana', thana)
      .set('area', area)
      .set('region', region);
    return this.http.get(`${ApiEndpoint.fcaURL}/fca-request/config/data`, {params: params});
  }

  fcaPlanConfigData(section: string, searchParam: string,filterParam: string, obj: any, param: string,pid:any): Observable<any> {
    let payload = {

      section: section,
      districts: obj.checked_district,
      thanas: obj.checked_thana,
      areas: obj.checked_area,
      selectedDate: obj.selectedDate,
      searchParam: obj.searchParam,
      filterParam: obj.filterParam,
      region: obj.region,
      param: param,
      pid: pid,
      paramLimit: obj.paramLimit,
      paramOffset: obj.paramOffset
    }
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request-plan/config/data`, payload);
  }


  saveTradeLicenseVerificationRequest(requestObj: any): Observable<any> {

    let payload = {...requestObj};

    payload.against = requestObj.against?.[0]?.name;
    payload.authorityDivision = requestObj.authorityDivision?.[0]?.name;
    payload.authorityDistrict = requestObj.authorityDistrict?.[0]?.name;
    payload.authorityThana = requestObj.authorityThana?.[0]?.name;
    payload.authorityArea = requestObj.authorityArea?.[0]?.name;
    payload.entityType = requestObj.entityType?.[0]?.id;
    payload.teamId = payload.team[0].id;
    payload.teamName = payload.team[0].name;
    payload.assessmentType = requestObj.assessmentType?.[0]?.name;
    payload.businessArea = requestObj.businessArea?.[0]?.name;
    payload.businessRegion = requestObj.businessRegion?.[0]?.name;
    payload.priority = requestObj.priority?.[0]?.id;
    payload.tlBusinessRegion = requestObj.tlBusinessRegion?.[0]?.name;
    payload.tlRegion = requestObj.tlRegion?.[0]?.name;
    payload.tradeLicenseExpiryDate = this.formatDate(requestObj?.tradeLicenseExpiryDate);
    payload.tradeLicenseIssueDate = this.formatDate(requestObj?.tradeLicenseIssueDate);

    delete payload.team;

    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/trade-license-verification/save`, payload);
  }

  formatDate(date) {
    console.log(date)
    if (date == null) {
      return;
    }
    if (typeof date === 'number') {
      date = new Date(date);
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  savePartyMember(partyMemberData: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/party-member/save`, partyMemberData);
  }

  saveMediaInsightInfo(obj: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/Media-insight-info/save`, obj);
  }

  getPartyMembers(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/party-member/list`, obj);
  }

  getApprovalMemos(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/media-insight-memo/list`, obj);
  }

  deletePartyMembers(data: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/party-member/delete`, data);
  }

  deleteMediaInsightInformation(data: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/Media-insight-information/delete`, data);
  }

  deleteCaoGroup(data: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/CAO-Group/delete`, data);
  }

  unAssignedCaoGroup(data: any): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/CAO-Group/unassigned`, data);
  }

  jointVisitAccountUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/joint-visit/account-upload`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/joint-visit/account-upload`, obj);
  }

  specialAccountUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/special-compliance/account-upload`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/special-compliance/account-upload`, obj);
  }

  fcaRequestList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/request/list`, obj);
  }

  downloadFilteredData(params: any): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-request/download`, params, '', 'blob', 'fca');
  }

  downloadSpecialData(params: any): Observable<any> {
    const url = `${ApiEndpoint.fcaURL}/fca-request/request-account/download`;
    return this.sse.cloudflareToleranceDownloadFile(url, params, '', 'blob', 'fca');
  }

  fetchFCAConfig(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/config`, obj);
  }

  fcaUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/upload`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/upload`, obj);
  }

  mediaInsightUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/media-insight/account-upload`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/media-insight/account-upload`, obj);
  }

  complianceSurveyUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/compliance-survey/account-upload`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/compliance-survey/account-upload`, obj);
  }

  withoutErrorAccountUpload(payload): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/remove/accounts`, payload);
  }

  posmDelete(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/delete/account/information`, obj);
  }

  deleteAccountInformation(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/delete/account/information`, obj);
  }

  fcaRequestLoadData(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/account/information`, obj);
  }

  tlvrData(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/account/information`, obj);
  }

  savePOSM(payload): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/save/posm`, payload)
  }

  assignCAO(payload): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/assign/cao`, payload)
  }

  specialFcaList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/special/fca`, obj);
  }

  saveMedia(payload): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/save/media-insight`, payload, '', true, "fca")
  }

  saveCompliance(payload): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/save/compliance-survey`, payload, '', true, "fca")
  }

  checkErrors(uploadRes: any, uniqueId: string, fcaTypeId: any, fcaRequestId: any, param: any, comp: any, mapData: any) {
    let failMessage = '';
    if (uploadRes?.message == 'Invalid Data Found' && param == 'fcaSubmit') {
      failMessage = `Some provided account(s) are already requested for FCA by other requestor(s). Do you want to proceed without them?`;
    } else if (uploadRes?.message == 'All Provided Accounts are already planned' && param == 'fcaSubmit') {
      failMessage = `Can not submit the assessment as all provided account(s) are already requested for FCA.`;
    } else {
      failMessage = `There are some information that are invalid. Please view the error report to know the details`;
    }


    if (uploadRes?.statusCode == 412 || uploadRes?.statusCode == 204) {
      this.alerts.toast('error', uploadRes?.message);
    }

    if (uploadRes?.message == 'Invalid Data Found' || uploadRes?.message == 'All Provided Accounts are already planned') {
      let type = '';
      if (param == 'fcaSubmit') {
        type = 'FCA Request Account Validate'
      } else {
        type = this.getFcaTypeName(fcaTypeId)
      }
      let initialState = {
        title: 'Upload Details',
        message: failMessage,
        truthyText: 'View Error Report ',
        falsyText: 'Cancel',
        uniqueId: uniqueId,
        fcaTypeId: fcaTypeId,
        param: param,
        fcaRequestId: fcaRequestId,
        failMessage: uploadRes?.message,
        comp: comp,
        uploadRes: uploadRes,
        mapData: mapData,
        type: type
      };
      this.modalService.show(ConfirmationModalFcaComponentComponent, {
        initialState,
        backdrop: 'static', keyboard: false,
        class: 'modal-dialog-centered'
      });
      return false;
    }

    return true;
  }

  checkEntityError(uploadRes: any, mapData: any) {
    if (uploadRes?.statusCode == 206) {
      let initialState = {
        uploadRes: uploadRes
      };
      this.modalService.show(EntityErrorReportComponent, {
        initialState,
        backdrop: 'static', keyboard: false,
        class: 'modal-dialog modal-dialog-centered'
      });
      return false
    }
    return true;
  }

  uploadResultSource = new Subject<any>();
  uploadResult$ = this.uploadResultSource.asObservable();

  updateUploadResult(component: string, action: string) {
    this.uploadResultSource.next({component, action});
  }

  saveJointVisitRequest(data: any) {

    const payload = {...data};

    payload.teamId = payload.team[0]?.id;
    payload.teamName = payload.team[0]?.name;
    payload.partyType = payload.partyType[0]?.id;
    payload.party = payload.party[0]?.id;
    // payload.startDate = this.formatDate(payload.startDate);
    // payload.endDate = this.formatDate(payload.endDate);

    delete payload.team;

    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/saveJointVisitAssessment`, payload)

  }

  formatSize(size: number): string {
    if (size === 0) return '0 B';

    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
  }


  saveSpecialFcaRequest(data: any) {

    const payload = {...data};


    payload.assessmentType = payload.assessmentType[0]?.name;
    payload.risks = payload?.assessmentRiskType;
    payload.teamId = payload.team[0]?.id;
    payload.teamName = payload.team[0]?.name;
    payload.requestType = payload.requestType[0]?.name;
    payload.requestAgainst = payload.requestAgainst[0]?.name;
    payload.assessmentBase = payload.assessmentBase?.[0]?.name;
    payload.geoAreaType = payload.geoAreaType?.[0]?.name;

    delete payload.team;

    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/saveSpecialFcaRequest`, payload)

  }

  getFcaTypeName(typeId: any) {
    switch (typeId) {
      case 1 :
        return 'Compliance-Survey';
      case 2 :
        return 'Special-Field-Compliance';
      case 3 :
        return 'Media-Insight';
      case 4 :
        return 'Joint-Visit';
      case 5 :
        return 'POSM';
      case 6 :
        return 'Trade-License';
      default:
        return '';

    }
  }

  uploadFiles(requestId: number, files: File[], source: any = []): Observable<any> {
    const formData = new FormData();
    formData.append('requestId', requestId.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }
    formData.append('source', JSON.stringify(source))
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/file/upload`, formData, {responseType: 'text'});
  }

  removeFiles(requestId: number, files: any[]): Observable<any> {
    const formData = new FormData();
    formData.append('requestId', requestId.toString());

    for (let i = 0; i < files.length; i++) {
      formData.append('removefiles', files[i]); // Convert file object to JSON string
    }

    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/file/remove`, formData, {responseType: 'text'});
  }


  sfcaAssignUpload(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-request/unassign/account`, obj, '', true, "fca");
    // return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/unassign/account`, obj);
  }

  deployCAOGroup(payload): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/deploy/cao-group`, payload, {responseType: 'text'})
  }

  getList(payload: any) {
    return this.http.post(`${ApiEndpoint.fcaURL}/organization/team/list`, payload);
  }

  getArea(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/fca/data`, obj);
  }

  changeStatus(selectedItems: number[], status: 'continue' | 'discontinue', remark: string | undefined) {
    let payload: any = {ids: selectedItems};
    (status == 'discontinue') && (payload.remark = remark);
    return this.http.post(`${ApiEndpoint.fcaURL}/organization/team/status/${status}`, payload);
  }

  getRemarks(id: number) {
    return this.http.get(`${ApiEndpoint.fcaURL}/organization/team/${id}/remarks`);
  }

  save(payload: any) {
    return this.http.post(`${ApiEndpoint.fcaURL}/organization/team/save`, payload);
  }

  checkErrorsSFCA(uploadRes: any, uniqueId: string, requestType: string, fcaRequestId: any, otherParam: string, uploadType: any, fcaTypeId: any) {

    let failMessage = `There are some ${requestType == 'Special FCA validation'}(s) that are invalid. Please view the error report to know the details`;
    if (uploadRes?.message == 'Invalid Data Found') {
      this.alerts.toast('error', 'An error occurred!');
      this.alerts.openConfirmationModal('Upload Details', failMessage, 'View Error Report ', 'Cancel')
        .pipe(take(1))
        .subscribe((res: boolean) => {
          if (res == true) {
            let initialState = {
              requestType: requestType,
              generatedId: uniqueId,
              uploadRes: uploadRes,
              uploadType: uploadType,
              fcaRequestId: fcaRequestId,
              otherParam: otherParam,
              fcaTypeId: fcaTypeId
            };

            this.modalService.show(ErrorReportComponent, {
              initialState,
              backdrop: 'static', keyboard: false,
              class: 'modal-dialog modal-dialog-centered'
            });
            setTimeout(() => {
              this.bsModalRef.hide()
            }, 600);
          }
          return;
        })


      return false;
    } else {
      this.alerts.toast('error', uploadRes?.message);
    }

    return true;
  }


  downloadSFcaErrorReport(obj: any): Observable<any> {
    const url = `${ApiEndpoint.fcaURL}/fca-request/sfca/error/download`;
    return this.sse.cloudflareToleranceDownloadFile(url, obj, '', 'blob', 'fca');
  }

  downloadAssignedList(obj: any): Observable<any> {
    const url = `${ApiEndpoint.fcaURL}/fca-request/assigned/download`;
    return this.sse.cloudflareToleranceDownloadFile(url, obj, '', 'blob', 'fca');
  }

  fcaReportList(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/issue/list`, obj);
  }

  downloadIssueReportData(params: any): Observable<any> {
    const url = `${ApiEndpoint.fcaURL}/fca-report/download`;
    return this.http.post(url, params, {responseType: 'blob'});
  }

  fcaIssueReport(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/issue`, obj);
  }

  downloadFcaReportDataTable(params: any): Observable<any> {
    const url = `${ApiEndpoint.fcaURL}/fca-report/datatable/download`;
    return this.http.post(url, params, {responseType: 'blob'});
  }

  getKpiDetails(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/kpi/data`, obj);
  }

  changeFcaReportStatus(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/change/status`, obj);
  }

  closeFcaReport(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/close`, obj);
  }

  deleteFcaRequest(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/delete`, obj)
  }

  getValidationList(obj): Observable<any> {
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/validation/v2/list`, obj, '', true, "fca");
  }

  downloadAssessment(obj): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/validation/download`, obj, '', 'blob', 'fca');
  }

  fetchAssessmentConfig(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/validation/config`, obj);
  }

  downloadEvidence(filePath: string) {
    return this.http.get(`${ApiEndpoint.queryServiceURL}/query/download/file?filePath=` + filePath, {responseType: 'blob'})
  }

  validateAssessment(obj, approveStatus) {
    return this.http.post(`${ApiEndpoint.fcaURL}/validation/validate?approveStatus=${approveStatus}`, obj);
  }

  getReportData(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/data/list`, obj);
  }

  addRecommendation(fcaIssueId, obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/addRecommendationAccount?selectionType=${obj.selectionType}&tableName=${obj.tableName}&issueId=${fcaIssueId}`, obj);
  }

  addBulkRecommendation(fcaIssueId, obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/addBulkRecommendation?selectionType=${obj.selectionType}&tableName=${obj.tableName}&issueId=${fcaIssueId}`, obj);
  }

  saveCrReportData(obj, approverData = null): Observable<any> {
    let currentRoleIndex = localStorage.getItem('roleIndex');
    obj.existedRoleName = JSON.parse(localStorage.getItem('currentRole'))[currentRoleIndex].roleName;

    if (obj.type == 'Approved From FCA Report' || obj.type == 'Final Submit' || obj.type == 'Final Submit') {
      obj.params = approverData;
      return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-report/approver/save`, obj, '', true, "fca");
    }
    return this.sse.cloudflareTolerance(`${ApiEndpoint.fcaURL}/fca-report/save`, obj, '', true, "fca");
  }

  getAddedTable(contentId: string): Observable<any> {
    return this.http.get(`${ApiEndpoint.fcaURL}/fca-report/get/table/${contentId}`);
  }

  saveReportFile(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/attachment/upload`, obj);
  }

  addContent(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/content/add`, obj, {responseType: 'text'});
  }

  getReportRecommendations(fcaIssueId: number, limit: number = 100, offset: number = 0): Observable<any> {
    let params = new HttpParams()
      .set('fcaIssueId', fcaIssueId)
      .set('limit', limit)
      .set('offset', offset);

    return this.http.get<any>(`${ApiEndpoint.fcaURL}/fca-report/recommendations`, {params});
  }

  getReportRecommendationAccounts(objectId: number, eventType: string, limit: number = 100, offset: number = 0): Observable<any> {
    let params = new HttpParams()
      .set('objectId', objectId)
      .set('eventType', eventType)
      .set('limit', limit)
      .set('offset', offset);
    return this.http.get<any>(`${ApiEndpoint.fcaURL}/fca-report/recommendation/accounts`, {params});
  }

  deleteRecommendation(id: number): Observable<void> {
    return this.http.get<void>(`${ApiEndpoint.fcaURL}/fca-report/delete/recommendation/${id}`);
  }

  deleteRecommendationAccount(id: number, eventType: string): Observable<void> {
    return this.http.get<void>(`${ApiEndpoint.fcaURL}/fca-report/recommendation/account/delete/${id}?eventType=${eventType}`);
  }

  bulkRecommend(accountNumbers: string, issueId: number, tableName: string): Observable<any> {
    const options = {params: {issueId: issueId, tableName}};
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/bulk-recommendation/validation`, accountNumbers, options);
  }

  bulkRecommendInvalidAccounts(accountNumbers: string, issueId: number, tableName: string): Observable<any> {
    const options: any = {
      params: {issueId: issueId, tableName},
      responseType: 'blob'
    };
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-report/bulk-recommendation/invalid-Accounts`, accountNumbers, options);
  }

  downloadReportFiles(param: any) {
    let httpParams = new HttpParams({fromObject: param});
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-report/download/report/files?`, {}, httpParams.toString(), 'blob')
  }


  getAllData(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/kpi/list`, obj);
  }
  downloadKPIListData(params: any): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-kpi/team/download`, params, '', 'blob', 'fca');
  }

  getMemberData(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/team-member-wise/kpi/list`, obj);
  }
  downloadMemberKPIListData(params: any): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-kpi/team-member/download`, params, '', 'blob', 'fca');
  }


  add(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/save`, obj);
  }

  caoSubmit(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/team-member-wise/save`, obj);
  }

  getDetails(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-kpi/save`, obj);
  }

  getData(obj) {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-type-data/data`, obj);
  }

  savePossibleActions(ids: string[], possibleAction: string, possibleActionRemark: string): Observable<void> {
    let params = new HttpParams();
    ids.forEach(id => {
      params = params.append('ids', id);
    });
    params = params.append('possibleAction', possibleAction);
    params = params.append('possibleActionRemark', possibleActionRemark);
    return this.http.post<void>(`${ApiEndpoint.fcaURL}/validation/save/possible-action`, {}, {params});
  }

  getDownload(params: any): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-type-data/download`, params, '', 'blob', 'fca');
  }

  requetDetailDownload(params: any): Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-request/request-detail/download`, params, '', 'blob', 'fca');
  }

  specialFcaCaoGroupDetail(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/fca-request/special/fca`, obj);
  }

  downloadTlvEvidence(fcaRequestId: number): Observable<Blob> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-request-plan/evidence/download/`, {fcaRequestId: fcaRequestId}, '', 'blob', 'fca');
  }

  getAssessmentDownloadData(obj): Observable<any> {
    return this.http.post(`${ApiEndpoint.fcaURL}/validation/assessment/download/data`, obj);
  }

  public exportExcel(obj: any):Observable<any> {
    // return this.http.post(`${ApiEndpoint.fcaURL}/validation/export`,obj,{responseType: 'blob'})
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/validation/export`, obj, '', 'blob', 'fca');
  }

  downloadKPIDetailData(params:any ):Observable<any> {
    return this.sse.cloudflareToleranceDownloadFile(`${ApiEndpoint.fcaURL}/fca-kpi/team/detail-data`, params, '', 'blob', 'fca');
  }
}

